import React from "react";
import axios from "axios";
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import api from "../common/api";
import MediaFile from "../common/MediaFile";
import LinearProgress from "@material-ui/core/LinearProgress";

class VehiclesZipImport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      dialogOpen: false,
      contract: { name: "" },
      saving: false,
      menu: { open: false },
      files: []
    };
  }

  componentDidMount() {}

  handleMenuClose = e => {
    var menu = this.state.menu;
    menu.open = !menu.open;
    menu.anchorEl = e ? e.currentTarget : menu.anchorEl;
    this.setState({ menu });
  };

  handleUploadFile = (file, meta_data) => {
    var files_state = this.state.files;
    var file = { file: file, meta_data: meta_data };
    files_state.push(file);
    this.setState({ files: files_state });
  };

  handleSubmit = e => {
    this.setState({ saving: true });
    e.preventDefault();
    var formData = new FormData();
    var i = 0;
    if (this.state.files) {
      this.state.files.map((val, idx) => {
        if (val.file !== "" && val.file !== undefined) {
          formData.set("file", val.file[0]);
          i++;
        }
      });
    }
    var errors = [];
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(api.vehicles().importZip(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var message = "Se realizo la carga correctamente.";
        if (response.data.vehicles_not_found)
          message +=
            " Patentes no encontradas:" +
            response.data.vehicles_not_found.join(",");
        this.setState({ excel_loaded: true, message: message, saving: false });
      })
      .catch(function(error) {
        var promise = new Promise(function(resolve, reject) {
          resolve(error.response.data);
          errors = error.response.data;
        });
        self.setState({
          errors: errors,
          files: [],
          excel_loaded: true,
          saving: false
        });
      });
  };

  render() {
    const handleRedirect = id => () => {
      window.location.href = "/vehicles";
    };
    var errors = [];
    if (this.state.errors) {
      var messages = Object.values(this.state.errors.message);
      messages.map((val, idx) => {
        var rows = Object.keys(val);
        rows.map((val2, idx2) => {
          var fields = Object.values(val[val2]);
          fields.map((val3, idx3) => {
            var message = "La linea " + val2 + ": " + val3[0];
            errors.push(message);
            /*return (
	          				<div style={{color: 'red'}}>Línea {row}: {val2[0]}</div>
	  					)*/
          });
        });
      });
    }
    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header pt-4">
          <PageTitle
            lg="12"
            title={"Alta masiva de documentación"}
            className="text-lg-left"
          />
        </Row>
        <Row>
          <Col md="12">
            <React.Fragment>
              <div className="mt-2">
                {this.state.loading ? (
                  <LinearProgress />
                ) : this.state.excel_loaded ? (
                  this.state.errors ? (
                    errors.map((val, idx2) => {
                      return <div className="mt-1">{val}</div>;
                    })
                  ) : (
                    <div>{this.state.message}</div>
                  )
                ) : (
                  <React.Fragment>
                    <MediaFile
                      onChange={this.handleUploadFile}
                      title="Agregar zip"
                      width={"15rem"}
                      height={"2rem"}
                      meta_data="comprobante"
                      maxFileSize={10000000}
                    />
                    <Button
                      disabled={this.state.saving === true ? true : false}
                      className="mt-2 mr-2"
                      variant="contained"
                      color="primary"
                      size="small"
                      style={{ fontSize: "0.75rem" }}
                      onClick={this.handleSubmit}
                    >
                      Cargar
                    </Button>
                  </React.Fragment>
                )}

                <Button
                  disabled={this.state.saving === true ? true : false}
                  className="mt-2"
                  variant="contained"
                  color="secondary"
                  size="small"
                  style={{ fontSize: "0.75rem" }}
                  onClick={e => {
                    window.location.href = "/vehicles";
                  }}
                >
                  Volver
                </Button>
              </div>
            </React.Fragment>
          </Col>
        </Row>
      </Container>
    );
  }
}
export default VehiclesZipImport;
